import React from "react";
import "./spinner.css";

export default function LoadingSpinner() {
  return (
    <div className="loading">
      <div className="loader">
      </div>
    </div>
  );
}